// Static shell actions; no runtime code parsing or parallel creation workflows.
document.addEventListener('DOMContentLoaded', () => {
    const bind = (id, handler) => document.querySelector(`[data-sicaf-shell="${id}"]`)?.addEventListener('click', handler);
    bind('0', () => App.navigate('dashboard'));
    bind('1', event => App.toggleDropdown('quick-create-dropdown', event));
    for (const [id, action] of Object.entries({2:'lead',3:'student',4:'professor',5:'subjects',6:'formations'})) {
        bind(id, () => App.runAdminAction(action));
    }
    bind('7', () => App.navigate('comunidad'));
    bind('8', () => App.navigate('profile'));
    bind('9', () => App.navigate('settings'));
    bind('10', () => SafeHTML.fire({title:'Ayuda y soporte',text:SchoolService.get('supportEmail')?`Para soporte técnico o incidencias, escriba a ${SchoolService.get('supportEmail')}.`:'Para soporte técnico o incidencias, contacte con la administración del centro.',icon:'info',confirmButtonColor:'#0d9488'}));
    // Logout belongs to App.setupHeaderInfo and waits for explicit confirmation.
});

// Pressing inside a dialog (e.g. selecting text in a field) and releasing over its backdrop
// makes the browser fire "click" on the backdrop, which closed the dialog and lost the form.
// Such a click is ignored everywhere; a real click on the backdrop still closes it.
(() => {
    let press = null;
    window.addEventListener('pointerdown', event => { press = { target: event.target, x: event.clientX, y: event.clientY }; }, true);
    window.addEventListener('click', event => {
        const start = press; press = null;
        if (!start || event.detail === 0 || !(start.target instanceof Node) || start.target === event.target ||
            !(event.target instanceof Element) || !event.target.contains(start.target)) return;
        const editing = start.target instanceof Element && start.target.closest('input, textarea, select, [contenteditable]:not([contenteditable="false"])');
        const dragged = Math.hypot(event.clientX - start.x, event.clientY - start.y) > 4;
        if (editing || dragged) { event.stopPropagation(); event.preventDefault(); }
    }, true);
})();
